import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { LoadingSpinner } from './ui/loading-spinner';

interface AdminRouteProps {
  children: React.ReactNode;
}

export const AdminRoute = ({ children }: AdminRouteProps) => {
  const { user, loading, hasRole } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (!user) {
        // Not logged in - redirect to auth
        navigate('/auth', { replace: true });
      } else if (!hasRole('admin') && !hasRole('dev')) {
        // Only admin/dev may enter the admin panel; everyone else
        // (staff, instructors, students, learners, guests) is sent back
        navigate('/student/dashboard', { replace: true });
      }
    }
  }, [user, loading, hasRole, navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LoadingSpinner />
      </div>
    );
  }

  if (!user || (!hasRole('admin') && !hasRole('dev'))) {
    return null;
  }

  return <>{children}</>;
};
